import { Observable } from 'rxjs';
import { IDialogApprovalRoute, IReturnDialogApprovalRoute } from '../../models/shared.services.interface';
import { bcpApprovalRouteComponent } from './bcpApprovalRoute.component';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class BcpApprovalRouteService {

  dialogRef: MatDialogRef<bcpApprovalRouteComponent>;

  constructor(private dialog: MatDialog) { }
  //constructor() { }
  public openDialog(serviceInput: IDialogApprovalRoute): Observable<boolean> {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();

    this.dialogRef = this.dialog.open(bcpApprovalRouteComponent, { data: serviceInput });
    matDialogConfig.position = { left: '0px', top: '0px' };
    this.dialogRef.updatePosition(matDialogConfig.position);

    return this.dialogRef.afterClosed();
    //Nothing can live after afterClosed.
  }
}

